import type { SubCustomersTranslations } from './types'

export const enTranslations: SubCustomersTranslations = {
  title: 'Customers',
  subtitle: 'Manage your customers',
  addCustomer: 'Add Customer',
  editCustomer: 'Edit Customer',
  deleteCustomer: 'Delete Customer',
  customerCode: 'Code',
  customerName: 'Name',
  customerPhone: 'Phone',
  selectCustomer: 'Select Customer',
  changeCustomer: 'Change Customer',
  noCustomer: 'No customer assigned',
  addNewCustomer: 'Add New Customer',
  createNewCustomer: 'Create New Customer',
  hideCreate: 'Hide',
  namePlaceholder: 'Enter customer name',
  phonePlaceholder: 'Enter phone number (optional)',
  searchPlaceholder: 'Search customers...',
  noCustomersFound: 'No customers found',
  deleteConfirmTitle: 'Delete Customer',
  deleteConfirmDescription: 'Are you sure you want to delete this customer?',
  saveSuccess: 'Customer saved successfully',
  saveError: 'Failed to save customer',
  deleteSuccess: 'Customer deleted successfully',
  deleteError: 'Failed to delete customer',
}
